// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 栏目管理接口
export const _getColumn = (params) => {
    return getRequest('/cmsCategory/get/column', params)
}
// 分页查询有效文章
export const _getValidByPage = (params) => {
    return getRequest('/cmsArticle/getValidByPage', params)
}
// 更新文章浏览量
export const _updatePageviews = (params) => {
    return postRequest('/cmsArticle/updatePageviews', params)
}
// 分页查询有效留言
export const _getValidPage = (params) => {
    return getRequest('/cmsGuestbook/getValidByPage', params)
}
// 获取推荐文章
export const _getRecommends = (params) => {
    return getRequest('/cmsArticle/recommends', params)
}

//获取翻页文章
export const _turningArticle = (params) => {
    return getRequest('/cmsArticle/turningArticle', params)
}